export enum TransactionFtsStatus {
  RJCT = 'RJCT',
  ACCP = 'ACCP',
}
